import LobbyView from "./LobbyView";
import "./lobby-view.scss";

export default LobbyView;
